import React from 'react'

export default function BuketsTableROCVehicle_Jupiter(props) {
  let { data } = props;
  return (
    <>
      {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={index}>
          <td >{x} </td>
        </tr>)
        // }
      })}
    </>
  );
}
